// Öffentliche Seite /download — erreichbar von der Startseite und per Link,
// mit oder ohne Anmeldung. Angemeldete finden dasselbe im Menü unter „App".
import { Link } from 'react-router-dom';
import { useSprache } from '../../../gemeinsam/lib/i18n';
import { LogoKachel } from '../../firma/komponenten/Logo';
import AppHerunterladen from '../komponenten/AppHerunterladen';

export default function Download() {
  const { t } = useSprache();
  return (
    <div className="min-h-full bg-white text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <header className="border-b border-slate-200 dark:border-slate-800">
        <div className="mx-auto flex max-w-4xl items-center gap-3 px-4 py-3.5 sm:px-6">
          <Link to="/" className="flex items-center gap-2.5">
            <LogoKachel />
            <span className="text-lg font-bold tracking-tight">LagerPro</span>
          </Link>
          <Link to="/anmelden" className="ms-auto text-sm font-medium text-marke-700 hover:underline dark:text-marke-300">{t('aktion.anmelden')}</Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-10 sm:px-6">
        <AppHerunterladen />
      </main>
    </div>
  );
}
